import { ImageListItem } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { NoImage } from "./NoImage";
import { base } from "../styles";

type Prop = {
  src?: string | null;
  title: string; // alt
  children?: ReactNode; // ImageListItemBar
  onClickImg?: () => void;
};

/**
 * 기본 이미지 카드 컴포넌트
 *
 * @param src?: 이미지 url 주소. BaseUrl 제하고 전달
 * @param title: 이미지 엑박인 경우 alt에 전달할 값
 * @param children?: 이미지 하단에 표출할 ImageListItemBar 필요시 전달
 * @param onClickImg?: 이미지 클릭 함수
 */
export const ImageCard = ({ src, title, children, onClickImg }: Prop) => {
  const [isImgErr, setIsImgErr] = useState(false); // 엑박 이미지 처리

  // src가 바뀌면 엑박상태 초기화
  useEffect(() => {
    setIsImgErr(false);
  }, [src]);

  return (
    <ImageListItem
      sx={{
        height: "280px",
        maxHeight: "280px",
        "& .MuiImageListItem-img": {
          height: "280px",
          maxHeight: "280px",
          borderRadius: base.border_radius,
          position: "relative",
        },
        width: "185px"
      }}
    >
      {src && !isImgErr ? (
        <img
          src={src}
          alt={`${title}이미지`}
          onClick={onClickImg}
          onError={() => setIsImgErr(true)}
          style={{
            cursor: onClickImg ? "pointer" : "default",
          }}
        />
      ) : (
        <NoImage height="280px" />
      )}
      {children}
    </ImageListItem>
  );
};
